import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ChevronDown } from "lucide-react";
// ✅ Import de la imagen local
import heroImage from "@/assets/images/hero/hero-principal.png";

export default function Hero() {
  return (
    <section className="relative h-screen min-h-[700px] w-full overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="Casa El Gavillero"
          className="w-full h-full object-cover animate-ken-burns"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/60" />
        <div className="absolute inset-0 hero-glow" />
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-6">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, delay: 0.3 }}
          className="text-white/70 text-sm tracking-[0.3em] uppercase mb-6 font-light"
        >
          Propiedad de Lujo Boutique
        </motion.p>

        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.4, delay: 0.5 }}
          className="font-serif-display text-white text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-light text-shadow-lux text-balance max-w-5xl"
        >
          Casa El Gavillero
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, delay: 0.8 }}
          className="text-white/80 text-lg md:text-xl font-light mt-6 max-w-2xl text-balance"
        >
          Una experiencia memorable de exclusividad y tranquilidad, donde cada
          detalle está diseñado para el descanso y la belleza.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, delay: 1.1 }}
          className="flex flex-col sm:flex-row gap-4 mt-10"
        >
          <a
            href="#propiedad"
            className="px-10 py-4 border border-white/40 text-white text-sm tracking-wide font-light hover:bg-white/10 transition-all duration-300"
          >
            Conocer la Propiedad
          </a>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 1.8 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10"
      >
        <a href="#historia" className="text-white/60 hover:text-white transition-colors block">
          <ChevronDown size={24} className="animate-bounce" />
        </a>
      </motion.div>
    </section>
  );
}